<div class="vs-global-message">
  <div class="alert alert-danger">
    <div class="icon-container float-left"></div>
    <div class="message-container float-left">
      <span class="message-header">{{ "savedCart.youhavealready" | cxTranslate }}</span>
      <span class="message-content"
        >{{ "savedCart.youhavealready" | cxTranslate }}
        <a class="routelink" routerLink="/saved-carts">{{ "savedCart.savedcart" | cxTranslate }}</a> {{ "savedCart.toremovesaved" | cxTranslate }}</span>
    </div>
    <button class="close" type="button"(click)="closeMsg()" >
      <em class="material-icons"> close </em>
    </button>
  </div>
</div>
